module.exports = __webpack_public_path__ + "img/keynote_2-sm.057a29b0.png";